"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userProfileMapper = void 0;
const UserInfoMapper_1 = require("./UserInfoMapper");
const userProfileMapper = (userProfile) => {
    const userInfo = (0, UserInfoMapper_1.userInfoMapper)(userProfile);
    return Object.assign(Object.assign({}, userInfo), { settings: userProfile.settings });
};
exports.userProfileMapper = userProfileMapper;
